import { render, staticRenderFns } from "./nursingDeploy.vue?vue&type=template&id=472b3ec3&scoped=true"
import script from "./nursingDeploy.vue?vue&type=script&lang=js"
export * from "./nursingDeploy.vue?vue&type=script&lang=js"
import style0 from "./nursingDeploy.vue?vue&type=style&index=0&id=472b3ec3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472b3ec3",
  null
  
)

export default component.exports